import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image with Parallax Effect */}
      <div
        className="absolute inset-0 bg-cover bg-center transform scale-105 transition-transform duration-1000"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1564078516393-cf04bd966897?w=1920&q=80)',
          transform: isVisible ? 'scale(1)' : 'scale(1.1)'
        }}
      />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-[#0a0a0c]" />

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        <div
          className={`transition-all duration-1000 delay-300 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <p className="text-[#FF8C42] text-sm tracking-[0.3em] uppercase mb-6 font-light">
            Started from 2004
          </p>
          <h1
            className="text-5xl md:text-7xl lg:text-8xl font-serif mb-6 text-white leading-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Finest Craft
            <br />
            <span className="text-[#FF8C42]">in Town</span>
          </h1>
          <p className="text-white/80 text-lg md:text-xl mb-12 max-w-2xl mx-auto leading-relaxed">
            Transforming spaces into timeless masterpieces with 21 years of excellence in interior design
          </p>
          <button
            onClick={scrollToServices}
            className="group bg-[#FF8C42] hover:bg-[#ff9d5c] text-white px-10 py-4 rounded-sm font-medium tracking-wide transition-all duration-300 hover:shadow-lg hover:shadow-[#FF8C42]/30 hover:scale-105"
          >
            View Projects
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToServices}
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white/60 hover:text-[#FF8C42] transition-colors animate-bounce"
      >
        <ChevronDown size={32} />
      </button>
    </section>
  );
};

export default Hero;